import { Modal } from 'react-bootstrap'

export const ModalCancelOrder = ({ 
    show, 
    onHide, 
    onConfirm, 
    deliveryStatus, 
    orderId,
    isLoading = false 
}) => {
    // Определяем текст в зависимости от статуса доставки
    const getCancelModalText = () => {
        if (deliveryStatus === 40) {
            return 'Вы уверены, что хотите отменить заказ №' + orderId + '?\n\n' +
                   'Заказ находится на стадии сборки. Отмена будет произведена БЕЗ удержания стоимости доставки.\n\n' +
                   'Вы получите полный возврат средств.'
        } else if (deliveryStatus === 50) {
            return 'Вы уверены, что хотите отменить заказ №' + orderId + '?\n\n' +
                   'Заказ уже готов к выдаче. При отмене будет УДЕРЖАНА стоимость доставки.\n\n' +
                   'Возврат будет произведен за вычетом стоимости доставки.'
        } else {
            return 'Вы уверены, что хотите отменить заказ №' + orderId + '?'
        }
    }

    const getStatusText = () => {
        if (deliveryStatus === 40) return 'Сборка'
        if (deliveryStatus === 50) return 'Готов к выдаче'
        if (deliveryStatus === 60) return 'Отправлен'
        if (deliveryStatus === 70) return 'Вручен'
        return 'Неизвестный статус'
    }

    const isFreeCancel = deliveryStatus === 40
    const isPaidCancel = deliveryStatus === 50

    return (
        <Modal
            show={show}
            onHide={onHide}
            className={'ModalCancelOrder'}
            centered
        >
            <Modal.Header className={'header'}>
                <h3>{isFreeCancel ? 'Бесплатная отмена' : 'Отмена заказа'}</h3>
            </Modal.Header>
            <Modal.Body className={'body'}>
                <p>{getCancelModalText()}</p>
                <div style={{ marginTop: '10px', padding: '10px', background: '#f5f5f5', borderRadius: '4px' }}>
                    <span>Статус доставки: </span>
                    <strong style={{ color: isFreeCancel ? 'green' : isPaidCancel ? 'orange' : 'inherit' }}>
                        {getStatusText()}
                    </strong>
                    {isFreeCancel && (
                        <span style={{ display: 'block', color: 'green', marginTop: '5px' }}>
                            ✓ Отмена без удержания стоимости доставки
                        </span>
                    )}
                    {isPaidCancel && (
                        <span style={{ display: 'block', color: 'orange', marginTop: '5px' }}>
                            ⚠ Стоимость доставки будет удержана
                        </span>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer className={'footer'}>
                <button 
                    className="cancel-modal-btn cancel-modal-btn-no"
                    onClick={onHide}
                    disabled={isLoading}
                >
                    Нет
                </button>
                <button 
                    className="cancel-modal-btn cancel-modal-btn-yes"
                    onClick={onConfirm}
                    disabled={isLoading}
                >
                    {isLoading ? 'Отмена...' : 'Да, отменить'}
                </button>
            </Modal.Footer>
        </Modal>
    )
}